module.exports = __webpack_public_path__ + "img/selected7-min.23523b48.png";